import { useEffect, useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { postData } from "../../api/apiMethod";
import "../../assets/css/style.scss";
import RunnBackground from "../../assets/svg/login/backgroundRunn.svg";
import MailIcon from "../../assets/svg/login/mailIcon.svg";
import playstationLogo from "../../assets/svg/Playstudio_logo.svg";
import LoginHeader from "../../component/Login-header";
import { ForgetPassword_URL } from "../../service/API_URL";
import { commonHeaders } from "../../service/Constant";
import "../Login/login.scss";
import { Link } from "react-router-dom";

export default function ForgetPassword() {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formData, setFormData] = useState({ username: "" });
  const [storeFrontAccess, setStoreFrontAccess] = useState("");
  const [errors, setErrors] = useState({});

  const isEmailValid = (email) => {
    const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
    return emailRegex.test(email);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
    if (name === "username" && value && !isEmailValid(value)) {
      setErrors({ ...errors, username: "Invalid email format" });
    }
  };

  const accessStore = async () => {
    const tenantLocalData = localStorage.getItem("tenantInfo");
    const tenantLocalDataParse = await JSON.parse(tenantLocalData);
    setStoreFrontAccess(tenantLocalDataParse?.superTenant);
  };

  // Handle blur event for email validation
  const handleBlur = (e) => {
    const { name, value } = e.target;
    if (name === "username" && formData.username && !isEmailValid(value)) {
      setErrors({
        ...errors,
        username: "Invalid email format",
      });
    } else {
      setErrors({
        ...errors,
        username: "",
      });
    }
  };

  const forgetPasswordAPI = async () => {
    if (!isEmailValid(formData.username)) {
      setErrors({
        ...errors,
        username: "Please enter a valid email",
      });
      return;
    }

    setIsSubmitting(true);

    const data = {
      email: formData.username,
      // deviceInfo: { deviceId: UUID_CODE(), deviceType },
    };

    try {
      const response = await postData(ForgetPassword_URL, data, {
        headers: commonHeaders,
      });

      if (response?.data?.success) {
        // alert("Password reset link sent successfully to your email!");
        toast.success("Password reset link sent successfully to your email!", {
          position: "bottom-right",
          autoClose: 3000,
        });
        setFormData({ username: "" });
      } else {
        // alert("Failed to send the password reset link. Please try again.");
        toast.error(
          "Failed to send the password reset link. Please try again.",
          {
            position: "bottom-right",
            autoClose: 3000,
          }
        );
      }
    } catch (error) {
      console.error("Error posting data:", error);
      // alert("Something went wrong, please try after sometime.");
      toast.error("Something went wrong, please try after sometime.", {
        position: "bottom-right",
        autoClose: 3000,
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  useEffect(() => {
    accessStore();
  }, []);

  return (
    <>
      <div className="loginPage">
        <LoginHeader />
        <div className="main">
          <>
            <img
              src={RunnBackground}
              alt="Background"
              className="bottom-background"
            />
            <div className="login-block">
              <div className="login-form">
                <div className="title">
                  <div
                    className="logo"
                    style={{
                      // backgroundImage: `url(${
                      //   storeFrontAccess?.darkThemeLogoImagePath
                      //     ? image_url + storeFrontAccess?.darkThemeLogoImagePath
                      //     : logoInvert
                      // })`
                      backgroundImage: `url(${playstationLogo})`,
                    }}
                  />
                </div>

                <div className="forgetBlock">
                  <div className="forget-title">Forgot password?</div>
                  <div className="desc">
                    Enter your email to reset your password
                  </div>
                </div>

                <div className="form-group forget-input">
                  <label className="form-label">Email address</label>
                  <div className="input-group input-group-sm">
                    <div className="input-group-prepend">
                      <img src={MailIcon} alt="Mail Icon" />
                    </div>
                    <input
                      name="username"
                      id="username"
                      type="text"
                      placeholder="Enter email address"
                      className="form-control"
                      value={formData.username}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                  </div>
                  {errors.username && (
                    <span className="error">{errors.username}</span>
                  )}
                </div>

                <button
                  onClick={forgetPasswordAPI}
                  className={`forget-btn ${
                    isSubmitting || !isEmailValid(formData.username)
                      ? "disabled"
                      : ""
                  }`}
                  type="button"
                  disabled={isSubmitting || !isEmailValid(formData.username)}
                >
                  {isSubmitting ? "Submitting..." : "Submit"}
                </button>

                <div className="return-block">
                  Return to{" "}
                  <Link to="/login" className="loginLink">
                    Login!
                  </Link>
                </div>
              </div>
            </div>
          </>
        </div>
      </div>
      <ToastContainer />
    </>
  );
}
